import { io } from "socket.io-client";
const config = require('../config');
const URL = config.production ? '/superTactico' : 'http://localhost:3000';

export default function(auth={}) {
    return io(URL, {
        autoConnect: false,
        auth
    });
}
